import React from 'react';
import { Route, Switch, useHistory } from 'react-router-dom';
import {
  EditGroupPage,
  EditUserPage,
  GroupsPage,
  NewGroupPage,
  NewUserPage,
  UsersPage,
} from '@ontruck/fe-core';
import config from 'config';
import { useSelector } from 'react-redux';
import '../../modules/emergencies/components/ui/emergencyPopup.css';
import { injectIntl } from 'react-intl';

function UserManagementModule({ match, intl }) {
  const token = useSelector((state) => state?.user?.access_token);
  const history = useHistory();

  const consumerConfig = {
    api_url: `${config.BASE_URL}/`,
    token,
    on_success: () => {},
    on_discard: () => {},
  };

  const groupsPageTranslations = intl.messages.components.UserManagementModule.groups;
  const groupFormTranslations = intl.messages.components.UserManagementModule.group_form;
  const newGroupPageTranslations = intl.messages.components.UserManagementModule.new_group;
  const editGroupPageTranslations = intl.messages.components.UserManagementModule.edit_group;

  const handleGoToNewGroup = () => {
    history.push(`${match?.url}/groups/new`);
  };

  const handleGoToGroupDetail = (groupId) => {
    history.push(`${match?.url}/groups/${groupId}`);
  };

  const handleGoToGroups = () => {
    history.push(`${match?.url}/groups`);
  };

  const usersPageTranslations = intl.messages.components.UserManagementModule.users;
  const userFormTranslations = intl.messages.components.UserManagementModule.user_form;
  const newUserPageTranslations = intl.messages.components.UserManagementModule.new_user;
  const editUserPageTranslations = intl.messages.components.UserManagementModule.edit_user;

  const handleGoToNewUser = () => {
    history.push(`${match?.url}/users/new`);
  };

  const handleGoToUserDetail = (userId) => {
    history.push(`${match?.url}/users/${userId}`);
  };

  const handleGoToUsers = () => {
    history.push(`${match?.url}/users`);
  };

  return (
    <Switch>
      <Route
        component={() => {
          return (
            <GroupsPage
              consumerConfig={consumerConfig}
              groupsPageTranslations={groupsPageTranslations}
              onGoToNewGroup={handleGoToNewGroup}
              onGoToGroupDetail={handleGoToGroupDetail}
            />
          );
        }}
        exact
        path={`${match?.url}/groups`}
      />
      <Route
        path={`${match.url}/groups/new/`}
        render={({ location, match }) => {
          return (
            <NewGroupPage
              key={location.key}
              consumerConfig={consumerConfig}
              onGoToGroups={handleGoToGroups}
              groupFormPageTranslations={newGroupPageTranslations}
              groupFormTranslations={groupFormTranslations}
            />
          );
        }}
      />
      <Route
        path={`${match.url}/groups/:groupId`}
        render={({ location, match }) => {
          const { groupId } = match.params;
          return (
            <EditGroupPage
              key={location.key}
              consumerConfig={consumerConfig}
              onGoToGroups={handleGoToGroups}
              groupFormPageTranslations={editGroupPageTranslations}
              groupFormTranslations={groupFormTranslations}
              groupId={groupId}
            />
          );
        }}
      />
      <Route
        path={`${match.url}/users`}
        exact
        render={({ location, match }) => {
          return (
            <UsersPage
              key={location.key}
              consumerConfig={consumerConfig}
              onGoToUserDetail={handleGoToUserDetail}
              usersPageTranslations={usersPageTranslations}
              onGoToNewUser={handleGoToNewUser}
            />
          );
        }}
      />
      <Route
        path={`${match.url}/users/new`}
        render={({ location, match }) => {
          return (
            <NewUserPage
              key={location.key}
              consumerConfig={consumerConfig}
              onGoToUsers={handleGoToUsers}
              userFormPageTranslations={newUserPageTranslations}
              userFormTranslations={userFormTranslations}
            />
          );
        }}
      />
      <Route
        path={`${match.url}/users/:userId`}
        render={({ location, match }) => {
          const { userId } = match.params;
          return (
            <EditUserPage
              key={location.key}
              consumerConfig={consumerConfig}
              onGoToUsers={handleGoToUsers}
              userFormPageTranslations={editUserPageTranslations}
              userFormTranslations={userFormTranslations}
              userId={userId}
            />
          );
        }}
      />
    </Switch>
  );
}

export default injectIntl(UserManagementModule);
